import {Button} from './Button';
import {PageHeader, Text} from './Text';

export function GenericError({
  error,
}: {
  error?: {message: string; stack?: string};
}) {
  const heading = `Something’s wrong here.`;
  let description = `We found an error while loading this page.`;

  // TODO hide error in prod?
  if (error) {
    description += `\n${error.message}`;
    // eslint-disable-next-line no-console
    console.error(error);
  }

  return (
    <>
      <div className="shop-details-area ptb-80">
        <div className="container">
          <div className="row"></div>
          <PageHeader heading={heading}>
            <Text width="narrow" as="p">
              {description}
            </Text>
            {error?.stack && (
              <pre
                style={{
                  padding: '2rem',
                  background: 'hsla(10, 50%, 50%, 0.1)',
                  color: 'red',
                  overflow: 'auto',
                  maxWidth: '100%',
                }}
                dangerouslySetInnerHTML={{
                  __html: addLinksToStackTrace(error.stack),
                }}
              />
            )}
            <Button width="auto" variant="secondary" to={'/'}>
              Take me to the home page
            </Button>
          </PageHeader>
        </div>
      </div>
    </>
  );
}

function addLinksToStackTrace(stackTrace: string) {
  return stackTrace?.replace(
    /^\s*at\s?.*?[(\s]((\/|\w\:).+)\)\n/gim,
    (all, m1) =>
      all.replace(
        m1,
        `<a href="vscode://file${m1}" class="hover:underline">${m1}</a>`,
      ),
  );
}
